import { useEffect, useState, type ReactNode } from "react";
import i18n, { detectInitialLocale, setLocale, type AppLocale } from "@/lib/i18n";

export function I18nProvider({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const loc = detectInitialLocale();
    if (i18n.language !== loc) {
      i18n.changeLanguage(loc);
    }
    if (typeof document !== "undefined") document.documentElement.lang = loc;
    setReady(true);
  }, []);
  // Render children immediately even before detect — SSR uses default 'de'.
  void ready;
  return <>{children}</>;
}

export function LanguageToggle({ className = "" }: { className?: string }) {
  const [lang, setLang] = useState<AppLocale>((i18n.language as AppLocale) || "de");
  useEffect(() => {
    const update = () => setLang((i18n.language as AppLocale) || "de");
    i18n.on("languageChanged", update);
    window.addEventListener("omselected-lang-change", update);
    return () => {
      i18n.off("languageChanged", update);
      window.removeEventListener("omselected-lang-change", update);
    };
  }, []);
  const other: AppLocale = lang === "de" ? "en" : "de";
  return (
    <button
      type="button"
      onClick={() => setLocale(other)}
      aria-label="Switch language"
      className={`eyebrow text-muted-foreground hover:text-foreground transition-colors ${className}`}
    >
      <span className={lang === "de" ? "text-foreground" : ""}>DE</span>
      <span className="mx-1 opacity-40">/</span>
      <span className={lang === "en" ? "text-foreground" : ""}>EN</span>
    </button>
  );
}